import React, { FC, ReactNode, useRef, Fragment } from 'react';
import clsx from 'clsx';
import { Tooltip } from './form-controls/Tooltip';
import { useTruncated } from '../hooks/useTruncated';

interface TruncatedTextProps {
  label: string;
  children?: ReactNode;
  className?: string;
}

export const TruncatedText: FC<TruncatedTextProps> = ({ label, children, className = '' }) => {
  const ref = useRef<HTMLDivElement>(null);
  const { isTruncated } = useTruncated(ref);

  return (
    <Fragment>
      {isTruncated && <Tooltip visible />}
      <div
        ref={ref}
        className={clsx('truncate max-w-32', className)}
        data-for={isTruncated && 'main'}
        data-tip={label}
        data-testid='truncated-text'
      >
        {children || label}
      </div>
    </Fragment>
  );
};
